<article>
  @switch (currentView) {
    @case (pageViews.DEFINITION) {
      <section>
        <app-definition (selectedTabName)="getTabName($event)" [productImage]="productImage" [isForecastScenario]="isForecastScenario"></app-definition>
      </section>
    }
    @case (pageViews.HISTORY) {
      <section>
        @if (data) {
          <app-history [info]="data"></app-history>
        }
      </section>
    }
  }
</article>
